import React, { useEffect, useState } from 'react';
import { useGTContext, GTProvider } from '../GTContext';
import { IconEdit } from 'src/components/CommonMenu/icons/IconEdit';
import * as S from './GTCInlineWrapper.styles';

interface GTCInlineWrapperProps {
  children: React.ReactNode;
}

export const GTCInlineWrapper: React.FC<GTCInlineWrapperProps> = ({ children }) => {
  const { itemHeight } = useGTContext();
  const [portalTarget] = useState(() => document.createElement('div'));

  useEffect(() => {
    document.body.appendChild(portalTarget);
    return () => {
      document.body.removeChild(portalTarget);
    };
  }, [portalTarget]);

  return (
    <GTProvider value={{ itemHeight, portalTarget }}>
      <S.Div $itemHeight={itemHeight} onClick={(e) => e.stopPropagation()} className="gt-inline-wrapper">
        {children}
        <S.EditIndicator>
          <IconEdit />
        </S.EditIndicator>
      </S.Div>
    </GTProvider>
  );
};
